/*
Akhila 04/20/2023 2698964415 Added bew feature map data transformation
Akhila 04/24/2023 2698964415 bug fixed and prepoulated data
Akhila 04/25/2023 2698964415 rename the usage dialoge box
Akhila 06/08/2023 2698964415 created date change to date created field and column
Sohel 10/25/2023 2698964415 Fixed Created By Dropdown Page Break Issue.
*/
import React, {useState, useContext, useRef, useEffect} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import MapDataTransformTable1 from './MapDataTransformTable1';
import {useSelector, useDispatch} from 'react-redux';
import {
  validateDataTransform,
} from '../../../../../../redux/reducers/DataManagerRecord';
import {
  fetchCreatedByDropDownData,
} from '../../../../../../redux/reducers/ReportMaster';
import * as Yup from 'yup';
import {createdByOptions} from '../../../../../../util/CreatedByForOptions';
const SearchMapDataTransform = ({
  mapDataTransform,
  exportManagerRecord,
  tempDataTranform,
  setTempDataTransform,
  setDataTransformOpen,
  managerRecordGroup,
  values,
  setFieldValue,
  handleDataTansformDialog,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dispatch = useDispatch();
  const tempUnCheckedRef = useRef([]);
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const {basicInfoData, dataTranformationData} = useSelector(
    ({dataManagerRecord}) => dataManagerRecord,
  );
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const handleSubmit = (data) => {
    // setSearchFlag(true);
    setSearchData(data);
    setSubmit(true);
  };
  useEffect(() => {
    if (
      (values && dataTranformationData?.conditions?.length > 0) ||
      dataTranformationData?.actions?.length > 0
    ) {
      const dataTransform = [...values.preprocessors];
      dataTransform.push({
        preprocessorName: dataTranformationData?.dMProcessor?.processorCode,
        conditions:
          dataTranformationData?.conditions?.map((item) => {
            return {...item,
              ruleCode:item.conditionCode ? item.conditionCode : "",
              condition: item?.compareValue ? item?.compareValue : '',
              field: {
                fieldName: item?.fieldName ? item?.fieldName :"",
                repositoryName: item?.repositoryName ? item?.repositoryName :"" ,
                dataType: item?.field1Type ? item?.field1Type : "",
              },
              selectField: {
                fieldName: item?.field2Name ? item?.field2Name :"",
                dataType: item?.field2Type ? item?.field2Type : "",
                repositoryName: item?.field2RepositoryName ? item?.field2RepositoryName :"",
              },
              expression: item?.rhsRuleExpression ? item?.rhsRuleExpression : '',
            }
          }) || [],
        actions:
          dataTranformationData?.actions?.map((item) => {
            return {
              ...item,
              parameter:item?.actionName === 'Change Status' && item?.rhsRuleExpression ?
                JSON.parse(item?.rhsRuleExpression) :
                item?.rhsRuleExpression || '',
              formulaExpression: item?.rhsFormulaExpression ? item?.rhsFormulaExpression : '',
           
              action: item?.actionName ? item?.actionName : '',
              dataManagerProcessorActionId: item?.dataManagerProcessorActionId ?
                item?.dataManagerProcessorActionId :
                0,
              field: {
                fieldName: item?.fieldName ? item?.fieldName : '',
                dataType:item?.fieldType ? item?.fieldType : '',
                repositoryName: item?.repositoryName ? item?.repositoryName : '',
              },
              selectField:
              item?.actionName === 'Error Record' && exportManagerRecord ?
                item?.fieldFromName :
                {
                  fieldName: item?.fieldFromName ? item?.fieldFromName : '',
                  dataType: item?.fieldFromType ? item?.fieldFromType : '',
                  repositoryName: item?.repositoryFromName ? item?.repositoryFromName : '',
                },
            }
          }) || [],
        resultExpCondition: dataTranformationData?.dMProcessor?.defaultOperator || '',
        result: dataTranformationData?.dMProcessor?.resultExpr || '',
        isDataTransformation: true,
        dmProcessorId: dataTranformationData?.dMProcessor?.dmProcessorId || 0,
      });
      setFieldValue('preprocessors', dataTransform);
      handleDataTansformDialog();
    }
  }, [dataTranformationData]);
  const validateDataTranfor = () => {
    const processorCode = tempDataTranform?.map((i) => {
      return i?.processorCode;
    });
    const payload = {
      processorCode: processorCode ? processorCode[0] : '',
      recordCode: basicInfoData?.recordCode ? basicInfoData?.recordCode : '',
      fileType: exportManagerRecord ? 'Export' : 'Import',
      moduleType: managerRecordGroup ? 'RecordGroup' : 'Record',
    };
    dispatch(validateDataTransform(payload));
  };

  // form initial values(2699761741)
  const initialValues = {
    code: '',
    createdBy: '',
    createdDate: null,
  };
  useEffect(() => {
    const type = exportManagerRecord ? 'exporttemplaterecord' : 'importtemplate';
    dispatch(fetchCreatedByDropDownData(type));
  }, [dispatch]);

  // reset Form data (2699761741)
  const onClear = () => {
    const data = {
      code: '',
      createdDate: null,
    };
    setSearchData(data);
  };

  return (
    <>
      <div className="col-12">
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {touched, errors, values, handleChange, resetForm, handleBlur, setFieldValue} =
              props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid
                        className=" new-standard-textfields align-items-center"
                        container
                        spacing={2}
                      >
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={3}
                          className="form-group account-guarantor"
                        >
                          <TextField
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            name="code"
                            // InputLabelProps={{ shrink: true }}
                            label="Data Transformation Name"
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder={`Enter Data Transformation Name`}
                            fullWidth
                          />
                        </Grid>
                        {
                          <Grid
                            item
                            xs={6}
                            md={4}
                            lg={3}
                            xl={2}
                            className="form-group account-guarantor"
                          >
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              name="createdBy"
                              id="createdBy"
                              size="small"
                              value={values.createdBy}
                              options={createdByData}
                              getOptionLabel={(option) => {
                                return option?.userLoginName ? option?.userLoginName : '';
                              }}
                              renderOption={(option) => {
                                return createdByOptions(option);
                              }}
                              onChange={(e, value) => {
                                setFieldValue('createdBy', value);
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    className={` ${classes.labelName}`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    label="Created By"
                                    placeholder="Select Created By"
                                  />
                                </div>
                              )}
                            />
                          </Grid>
                        }
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={2}
                          className="form-group account-guarantor"
                        >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              className={` ${classes.labelName}`}
                              format="MM/dd/yyyy"
                              placeholder="MM/DD/YYYY"
                              fullWidth
                              value={values.createdDate}
                              name="createdDate"
                              onBlur={handleBlur}
                              inputVariant="outlined"
                              helperText=""
                              label="Date Created"
                              onChange={(val) => {
                                setFieldValue('createdDate', val);
                              }}
                              autoOk
                              margin="dense"
                              touched={touched?.createdDate}
                              error={Boolean(touched?.createdDate && errors?.createdDate)}
                            />
                          </MuiPickersUtilsProvider>
                          <FormHelperText variant="outlined">
                            {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                          </FormHelperText>
                        </Grid>
                        <Grid item md={7} lg={7} xl={2} className="form-group">
                          <div className="d-flex justify-content-xl-start justify-content-md-end">
                            <Button
                              variant="outlined"
                              className={`reset-btn mr-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setSubmit(true);
                                resetForm();
                                onClear();
                                setTempDataTransform([]);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn ml-1 ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </Grid>
                        <Grid item md={5} lg={5} xl={3} className="form-group">
                          <div className="d-flex  justify-content-md-end">
                            <Button
                              aria-label="close"
                              variant="outlined"
                              className={`mr-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                setDataTransformOpen(false);
                              }}
                            >
                              Close
                            </Button>
                            <Button
                              aria-label="save"
                              variant="outlined"
                              className={`ml-1 search-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                //   const obj = tempSelectFunc("recordCode", "", tempUnCheckedRef);
                                //   if (mapDataTransform) {
                                //     const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                //       // records,
                                //       obj,
                                //       "recordCode"
                                //     );
                                //     const allSelectedRows = [...newSelectedRows, ...tempDataTranform];
                                //     // setRecords(allSelectedRows);
                                //     setTempDataTransform(allSelectedRows || []);
                                //   }
                                validateDataTranfor();
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <MapDataTransformTable1
          mapDataTransform={mapDataTransform}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          exportManagerRecord={exportManagerRecord}
          tempDataTranform={tempDataTranform}
          setTempDataTransform={setTempDataTransform}
          setDataTransformOpen={setDataTransformOpen}
          tempUnCheckedRef={tempUnCheckedRef}
          values={values}
        />
      </div>
    </>
  );
};
export default SearchMapDataTransform;
